import React, { useState } from 'react';
import { Check } from 'lucide-react';
export function OfferSelector() {
  const [selected, setSelected] = useState<'esencial' | 'completa'>('completa');
  const links = {
    esencial: 'https://checkout.solucionesya.shop/cart/48947688734968:1',
    completa: 'https://checkout.solucionesya.shop/cart/48947702497528:1'
  };
  return <div className="w-full max-w-[640px] mx-auto flex flex-col items-center" data-id="element-230">
      <div className="flex flex-col gap-3 w-full mb-5 sm:mb-6" data-id="element-231">
        {/* Completa Row (preselected, destacada) */}
        <div onClick={() => setSelected('completa')} className={`relative cursor-pointer rounded-2xl p-3.5 sm:p-4 border-2 transition-all text-left flex items-center gap-3 sm:gap-4 ${selected === 'completa' ? 'border-violeta bg-white shadow-[0_8px_30px_rgba(127,119,221,0.2)] ring-2 ring-violeta/20' : 'border-[#EAEAEA] bg-white/90 hover:border-violeta/50 opacity-70'}`} data-id="element-232">
          {/* Radio indicator */}
          <div className={`flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'completa' ? 'border-violeta bg-violeta' : 'border-gray-300 bg-white'}`} data-id="element-233">
            {selected === 'completa' && <Check size={14} className="text-white" strokeWidth={3} data-id="element-234" />}
          </div>

          {/* Left: name + includes */}
          <div className="flex-1 min-w-0" data-id="element-235">
            <div className="flex items-center gap-2 flex-wrap mb-0.5" data-id="element-236">
              <span className="text-[12px] sm:text-[14px] font-extrabold uppercase tracking-wider text-violeta" data-id="element-237">
                Completa
              </span>
              <span className="bg-violeta text-white text-[8px] sm:text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider whitespace-nowrap shadow-sm" data-id="element-238">
                ⭐ Más Elegida
              </span>
            </div>
            <div className="flex flex-wrap items-center gap-x-3 gap-y-0.5 text-[10px] sm:text-[12px] text-oscuro" data-id="element-239">
              <span className="flex items-center gap-1" data-id="element-240">
                <Check size={11} className="text-verde flex-shrink-0" data-id="element-241" /> 8 tomos
                + 3 bonos
              </span>
              <span className="flex items-center gap-1" data-id="element-242">
                <Check size={11} className="text-verde flex-shrink-0" data-id="element-243" />{' '}
                <span className="font-bold" data-id="element-244">Fidelización y Precios</span>
              </span>
            </div>
          </div>

          {/* Right: prices */}
          <div className="flex-shrink-0 text-right" data-id="element-245">
            <div className="text-[11px] sm:text-[13px] text-gris line-through leading-none mb-0.5" data-id="element-246">
              $43.990
            </div>
            <div className="text-[19px] sm:text-[24px] font-black text-oscuro leading-none" data-id="element-247">
              $27.990
            </div>
          </div>
        </div>

        {/* Esencial Row */}
        <div onClick={() => setSelected('esencial')} className={`relative cursor-pointer rounded-2xl p-3.5 sm:p-4 border-2 transition-all text-left flex items-center gap-3 sm:gap-4 ${selected === 'esencial' ? 'border-rosa bg-white shadow-[0_4px_20px_rgba(212,83,126,0.15)] ring-2 ring-rosa/20' : 'border-[#EAEAEA] bg-white/90 hover:border-rosa/50 opacity-70'}`} data-id="element-248">
          {/* Radio indicator */}
          <div className={`flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'esencial' ? 'border-rosa bg-rosa' : 'border-gray-300 bg-white'}`} data-id="element-249">
            {selected === 'esencial' && <Check size={14} className="text-white" strokeWidth={3} data-id="element-250" />}
          </div>

          {/* Left: name + includes */}
          <div className="flex-1 min-w-0" data-id="element-251">
            <div className="text-[12px] sm:text-[14px] font-extrabold uppercase tracking-wider text-gris mb-0.5" data-id="element-252">
              Esencial
            </div>
            <div className="flex flex-wrap items-center gap-x-3 gap-y-0.5 text-[10px] sm:text-[12px] text-oscuro" data-id="element-253">
              <span className="flex items-center gap-1" data-id="element-254">
                <Check size={11} className="text-verde flex-shrink-0" data-id="element-255" /> 6 tomos
                + 3 bonos
              </span>
              <span className="flex items-center gap-1" data-id="element-256">
                <Check size={11} className="text-verde flex-shrink-0" data-id="element-257" /> Imagen
                y gestión
              </span>
            </div>
          </div>

          {/* Right: prices */}
          <div className="flex-shrink-0 text-right" data-id="element-258">
            <div className="text-[11px] sm:text-[13px] text-gris line-through leading-none mb-0.5" data-id="element-259">
              $34.990
            </div>
            <div className="text-[19px] sm:text-[24px] font-black text-oscuro leading-none" data-id="element-260">
              $19.990
            </div>
          </div>
        </div>
      </div>

      <a href={links[selected]} className={`w-full text-center text-white text-[15px] sm:text-[17px] font-bold py-3.5 sm:py-4 px-6 rounded-full transition-all tracking-wide shadow-lg hover:-translate-y-0.5 ${selected === 'completa' ? 'bg-gradient-to-br from-violeta to-[#6059C8] shadow-[0_8px_30px_rgba(127,119,221,0.45)]' : 'bg-gradient-to-br from-rosa to-rosa-oscuro shadow-[0_8px_30px_rgba(212,83,126,0.45)]'}`} data-id="element-261">
        {selected === 'completa' ? '✨ QUIERO LA OFERTA COMPLETA' : '💅 QUIERO LA OFERTA ESENCIAL'}
      </a>
    </div>;
}